import React from 'react';
import { useUpgradeComplete, UpgradeCompleteContent } from '../features/upgradeComplete';

type UpgradeCompletePageProps = {};

export const UpgradeComplete: React.FC<UpgradeCompletePageProps> = () => {
  const { isRedirecting } = useUpgradeComplete();

  return <UpgradeCompleteContent isRedirecting={isRedirecting} />;
};
